]
<template>
    <b-modal
        id="add-sub-assignment-modal"
        ref="add-sub-assignment-modal"
        :title="$t('assignment.add_sub_assignment')"
        :ok-title="$t('common.add')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="onOk"
        @show="onShow"
        modal-class="apprentice-default-modal">
        <!-- name -->
        <div class="content">
            <b-alert
                v-if="hasError"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>
            <b-form-group
                :label="$t('assignment.sub_assignment_name')"
                label-for="name-sub-assignment-input">
                <b-form-input
                    id="name-sub-assignment-input"
                    v-model="name"
                    :placeholder="$t('assignment.sub_assignment_name')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../../../app';

const subAssignmentOrds = ords.use('subAssignment');

export default {
    name: 'design-2021-assignment-edit-add-sub-assignment-modal-component',
    props: ['assignmentIn'],
    data() {
        return {
            name: null,
            hasError: false,
            errorMessage: '',
        };
    },
    methods: {
        onOk(bvModalEvent) {
            this.checkForErrors();

            if (this.hasError) {
                bvModalEvent.preventDefault();
                return;
            }

            const values = {
                name: this.name,
                assignment_id: this.assignmentIn.id,
                order: this.assignmentIn.sub_assignments.length + 1,
            };

            this.alert.saving(
                this.$t('assignment.add_sub_assignment'),
                this.$t('assignment.sub_assignment_being_added'),
            );
            this.axios.post(this.routes.subAssignment(), values).then(
                (response) => {
                    this.assignmentIn.addRelation('sub_assignments', response.data);
                    this.$emit('sub-assignment-added', response.data.id);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onShow() {
            this.name = null;
            this.hasError = false;
        },

        checkForErrors() {
            this.hasError = false;

            if (!this.name) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.sub_assignment_name_not_empty');
            }

            if (this.name && this.name.length > 191) {
                this.hasError = true;
                this.errorMessage = this.$t('assignment.sub_assignment_name_not_191_characters');
            }
        },
    },

    computed: {
        maxCharState() {
            if (this.name) {
                return this.name.length < 192;
            }
        },
    },
};
</script>

<style scoped lang="scss"></style>
